import React from "react";

import Image from "next/image";

import Radio, {
  WrapperInputs,
} from "@CheckoutOnepageOffers/components/atoms/Radio";
import RadioCreditCard from "@CheckoutOnepageOffers/components/atoms/RadioCreditCard";
import { useCheckoutOnepageOffersContext } from "@CheckoutOnepageOffers/provider/useCheckoutOnepageOffersContext";
import BilletSVG from "@payment/assets/BilletSVG";
import CreditCardSVG2 from "@payment/assets/CreditCardSVG2";
import PixSVG2 from "@payment/assets/PixSVG2";
import { useCreditCard } from "@payment/hooks/useCreditCard";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { handleBrand } from "@payment/utils/handleBrand";
import { handleCard } from "@payment/utils/handleCard";

import {
  DeleteButton,
  DeleteIcon,
  LabelText,
  LabelTextMobile,
  PaymentMethodsSection,
  Title,
  WrapperIcon,
  WrapperPaymentMethods,
} from "./styles";

const PaymentMethods = () => {
  const { offer } = useCheckoutOnepageOffersContext();

  const { removeCreditCardRequest } = useCreditCard();
  const { checkoutOnePageState, checkoutOnePageDispatch } =
    useCheckoutOnepageOffersContext();
  const { creditCardState, creditCardDispatch, country } = useCheckoutContext();

  const payment_methods = offer.offer.details.payment_methods;

  const columns = Object.values(payment_methods).filter(
    (value) => value === true,
  ).length;

  const setNewCreditCardPayment = () => {
    checkoutOnePageDispatch({
      type: "SET_CHECKOUT_ONE_PAGE_SETTINGS",
      payload: {
        methodPaymentSelected: "credit_card",
      },
    });
  };

  const setBankSlipPayment = () => {
    checkoutOnePageDispatch({
      type: "SET_CHECKOUT_ONE_PAGE_SETTINGS",
      payload: {
        methodPaymentSelected: "boleto",
      },
    });
  };

  const setPixPayment = () => {
    checkoutOnePageDispatch({
      type: "SET_CHECKOUT_ONE_PAGE_SETTINGS",
      payload: {
        methodPaymentSelected: "pix",
      },
    });
  };

  const setCreditCardPayment = (cardId) => {
    checkoutOnePageDispatch({
      type: "SET_CHECKOUT_ONE_PAGE_SETTINGS",
      payload: {
        methodPaymentSelected: cardId,
      },
    });
  };

  const removeCreditCard = async (cardId: number) => {
    const response: any = await removeCreditCardRequest(cardId);

    if (response?.status === 200) {
      const newCreditCardList = creditCardState.creditCardList.filter(
        (card) => card.id !== cardId,
      );

      creditCardDispatch({
        type: "SET_CREDIT_CARD_STATE",
        payload: {
          creditCardList: newCreditCardList,
        },
      });
    }
  };

  const generateCreditCardLabel = (card) => {
    return (
      <LabelText>
        <WrapperIcon>
          <Image
            src={handleBrand(card.brand, "light")}
            width={24}
            height={24}
            alt=""
          />
        </WrapperIcon>
        {handleCard(card.brand)} **** {card.last_digits}
      </LabelText>
    );
  };

  const generateCreditCardButton = (card) => {
    return (
      <DeleteButton type="button" onClick={() => removeCreditCard(card.id)}>
        <DeleteIcon />
      </DeleteButton>
    );
  };

  return (
    <PaymentMethodsSection>
      {country === "Brasil" && <Title>Como você prefere pagar?</Title>}
      {(payment_methods.credit_card || country !== "Brasil") &&
        creditCardState.creditCardList?.map((card) => (
          <WrapperInputs key={card.id}>
            <RadioCreditCard
              id={card.id}
              value={card.id}
              name="payment_method"
              label={generateCreditCardLabel(card)}
              button={generateCreditCardButton(card)}
              onClick={() => setCreditCardPayment(card.id)}
              disabled={offer.maintenance.credit_card}
            />
          </WrapperInputs>
        ))}
      {country === "Brasil" && (
        <WrapperPaymentMethods mobile columns={columns}>
          {payment_methods?.credit_card && (
            <Radio
              mobile
              id="credit-card"
              value="credit_card"
              name="payment_method"
              label={
                <LabelTextMobile>
                  <CreditCardSVG2 /> Cartão
                </LabelTextMobile>
              }
              onClick={setNewCreditCardPayment}
              checked={
                checkoutOnePageState.methodPaymentSelected === "credit_card"
              }
              disabled={offer?.maintenance?.credit_card}
            />
          )}

          {payment_methods?.boleto && (
            <Radio
              mobile
              id="boleto"
              value="boleto"
              label={
                <LabelTextMobile>
                  <BilletSVG /> Boleto
                </LabelTextMobile>
              }
              name="payment_method"
              onClick={setBankSlipPayment}
              checked={checkoutOnePageState.methodPaymentSelected === "boleto"}
              disabled={offer?.maintenance?.boleto}
            />
          )}

          {payment_methods?.pix && (
            <Radio
              mobile
              id="pix"
              value="pix"
              label={
                <LabelTextMobile>
                  <PixSVG2 /> PIX
                </LabelTextMobile>
              }
              name="payment_method"
              onClick={setPixPayment}
              checked={checkoutOnePageState.methodPaymentSelected === "pix"}
              disabled={offer?.maintenance?.pix}
            />
          )}
        </WrapperPaymentMethods>
      )}
    </PaymentMethodsSection>
  );
};

export default PaymentMethods;
